var _path, _path2, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 220,
    viewBox: "0 0 248 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8517 57.581C67.8259 62.0178 70.9015 64.3144 70.2573 65.3098C69.3081 66.7763 69.2031 70.9307 69.2031 70.9307C69.2031 70.9307 51.9841 75.4977 46.0102 78.6595C40.0363 81.8213 40.0363 95.8736 40.0363 95.8736C40.0363 95.8736 38.2793 97.2789 38.1036 100.792C37.9279 104.305 40.5634 106.764 40.5634 106.764L41.4419 129.424L37.9279 131.883C37.9279 131.883 21.236 146.462 24.3987 156.474C27.5614 166.487 35.9951 164.203 39.6849 163.676C43.3747 163.149 44.6046 155.069 45.1317 156.65C45.6588 158.231 48.2904 162.356 48.2904 162.356C48.2904 162.356 44.2532 171.581 44.4289 180.89C44.6046 190.2 54.6197 195.294 60.7693 195.47C66.9189 195.645 73.2443 187.214 73.2443 187.214C73.2443 187.214 85.7603 198.565 114.71 194.24C129.996 191.956 143.597 182.476 152.135 174.215C157.582 168.946 164.434 159.812 164.434 159.812C164.434 159.812 168.827 162.622 174.801 159.812C180.775 157.001 181.478 151.029 181.126 146.462C180.775 141.895 173.098 135.683 173.098 135.683C173.098 135.683 176.206 117.303 176.734 109.926C177.261 102.548 176.206 92.8875 174.625 81.2943C174.127 77.6394 179.896 67.4176 188.154 66.0124C196.412 64.6072 205.198 60.3915 209.414 57.7567C213.631 55.1219 224.174 38.0834 223.998 35.0973C223.822 32.1112 223.822 29.3007 218.375 30.0033C212.929 30.7059 206.867 37.2051 194.304 35.6242C179.295 33.7355 176.558 44.5826 176.558 44.5826C176.558 44.5826 176.558 30.8816 163.029 30.7059C149.5 30.5303 142.12 27.8955 140.012 27.0172C137.903 26.1389 131.226 22.4502 130.348 25.2607C129.469 28.0711 132.456 40.7182 136.498 48.0957C140.539 55.4732 151.081 56.3514 159.339 60.5671C167.597 64.7828 160.569 71.809 160.569 71.809C160.569 71.809 140.409 66.3637 119.103 66.3637C107.858 66.3637 91.2246 67.1834 91.2246 67.1834C91.2246 67.1834 89.4676 64.2851 87.1834 64.0217C87.8862 59.4254 86.2463 59.2205 84.8114 58.3129C84.6671 58.2216 82.8787 52.3114 78.7496 48.3006C75.6732 45.3123 73.42 28.7737 69.9059 35.7999C66.3918 42.8261 67.0361 52.3114 68.8517 57.581H68.8517Z",
    fill: "url(#paint0_linear_7139_36236)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.457 142V135.75H107.707V142H101.457ZM101.457 129.5V117H113.957V123.25H107.707V129.5H101.457ZM88.957 110.75V104.5H95.207V110.75H88.957ZM113.957 117V104.5H120.207V117H113.957ZM95.207 104.5V98.25H113.957V104.5H95.207Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.722229,
    width: 247,
    height: 218.25,
    rx: 11.5,
    stroke: "url(#paint1_linear_7139_36236)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7139_36236",
    x1: 124,
    y1: 24.2222,
    x2: 124,
    y2: 195.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A00E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947328,
    stopColor: "#2D75E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7139_36236",
    x1: 124,
    y1: 0.222229,
    x2: 124,
    y2: 219.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A00E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947328,
    stopColor: "#2D75E2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtwork);
export default __webpack_public_path__ + "static/media/artwork.c2e7c9e212fdaa05ea34bbf34d0eac5f.svg";
export { ForwardRef as ReactComponent };